import type { OpportunityStatus, RunnerStatusMarketDetails } from '@ps/web-sports-api-types';
import { runnerStatusMap } from '@ps/web-sports-enums';

const getRunnerStatus = (status: OpportunityStatus): RunnerStatusMarketDetails =>
  runnerStatusMap[status];

export default getRunnerStatus;
